import React, {useEffect, useState} from "react";
import {useLanguageForShared} from "../../../../../../../shared/utils/languages/useLanguageForShared";
import {FormElements} from "../../../../../../../shared/bootstrap/form/FormElements";
import FormGroup from "../../../../../../../shared/bootstrap/form/form-group/FormGroup";
import InputCustom from "../../../../../../../shared/bootstrap/form/input/InputCustom";
import {useTemplateFormLOX_POC_TOC_COX} from "../data/useTemplateFormLOX_POC_TOC_COX";


export function PrescriptionTemplate({dataForm, changeValue, errors, setData, isSubmit, paramsPrescription, type}) {
    const {t} = useLanguageForShared()
    const {
        hasLevelData = false,
        hasTypeflow = false,
        hasStroller = false,
        title = t('sg.prescription'),
    } = paramsPrescription ?? {};


    const [sum, setSum] = useState();
    const {
        formStructurePrescription,
        formStructureStroller,
        formStructurePulsedFlow,
        formStructureModel,
    } = useTemplateFormLOX_POC_TOC_COX(t, dataForm);

    const getValue = (val) => {
        return val ? parseInt(val) : 0;
    };

    const prefix = hasLevelData ? 'level' : 'flow';

    useEffect(() => {
        const total =
            getValue(dataForm?.[`${prefix}_restHourDie_${type}`]) +
            getValue(dataForm?.[`${prefix}_underStressHourDie_${type}`]) +
            getValue(dataForm?.[`${prefix}_nightHourDie_${type}`]);

        setSum(total);
    }, [
        dataForm?.[`${prefix}_restHourDie_${type}`],
        dataForm?.[`${prefix}_underStressHourDie_${type}`],
        dataForm?.[`${prefix}_nightHourDie_${type}`],
    ]);


    return (
        <div className="form-card">
            <span className="form-card__title">{title}</span>

            <div className="form-card__content">
                <FormElements
                    structure={formStructureModel(type)}
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                />

                <FormElements
                    structure={formStructurePrescription(type, hasLevelData)}
                    dataForm={dataForm}
                    changeValue={changeValue}
                    errors={errors}
                    isSubmit={isSubmit}
                />

                <div className="row">
                    <div className="col-sm-12 col-lg-3">
                        <FormGroup
                            label={{label: t("prescription.template.check24h.label")}}
                            error={{
                                isVisible: sum > 24,
                                message: t("prescription.template.check24h.error")
                            }}
                        >
                            <InputCustom
                                type="text"
                                name="check24h"
                                error={sum > 24}
                                value={sum}
                                disabled
                            />
                        </FormGroup>
                    </div>
                </div>

                {hasTypeflow && (
                    <FormElements
                        structure={formStructurePulsedFlow(type)}
                        dataForm={dataForm}
                        changeValue={changeValue}
                        errors={errors}
                        isSubmit={isSubmit}
                    />
                )}

                {hasStroller && (
                    <FormElements
                        structure={formStructureStroller}
                        dataForm={dataForm}
                        changeValue={changeValue}
                        errors={errors}
                        isSubmit={isSubmit}
                    />
                )}
            </div>
        </div>

    );
}
